<aa-dropdown
  displayText="Filter"
  [openMenu]="_open"
  [buttonClasses]="'primary selector link'"
  [rightIcon]="{ definition: faCaretDown }"
  (toggle)="toggleDD($event)"
  [buttonTitle]="(_open ? 'Close' : 'Open') + 'Filter'"
  [buttonRole]="'button'"
>
  <ul role="menu">
    <div>
      <div class="w-100">
        <div class="scrollable">
          <div class="dropdown-column">
            <p class="filter-heading">Work Types</p>

            @for (
              activityType of multiSelectActivityTypes;
              track activityType
            ) {
              <div class="custom-control custom-checkbox highlight-on-hover">
                <input
                  [id]="activityType.data.id"
                  class="custom-control-input"
                  type="checkbox"
                  [checked]="activityType.selected"
                  (change)="onActivityTypeSelected(activityType)"
                />
                <label
                  [for]="activityType.data.id"
                  class="custom-control-label"
                  >{{ activityType.name }}</label
                >
              </div>
            }
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-column">
            <p class="filter-heading">Year</p>
            @for (
              activityYear of multiSelectActivityYears;
              track activityYear
            ) {
              <div class="custom-control custom-checkbox highlight-on-hover">
                <input
                  [id]="activityYear.data.name"
                  class="custom-control-input"
                  type="checkbox"
                  [checked]="activityYear.selected"
                  (change)="onActivityYearSelected(activityYear)"
                />
                <label
                  [for]="activityYear.data.name"
                  class="custom-control-label"
                >
                  {{ activityYear.name }}
                </label>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="flex space-around" style="margin-top: 25px">
        <button (click)="cancelButtonClick()" [ngStyle]="{ width: '40%' }">
          Cancel
        </button>
        <button (click)="applyButtonClick()" [ngStyle]="{ width: '40%' }">
          Apply
        </button>
      </div>
    </div>
  </ul>
</aa-dropdown>
